module.exports = __webpack_public_path__ + "static/BannerGoldenAge2x-5767ded858466d4b9b411941b0cc3204.jpg";